// Thresholds match the mobile app's survey sheet (SurveyProvider.tsx).
export const SHEET_DISMISS_DISTANCE_RATIO = 0.3;
export const SHEET_DISMISS_VELOCITY = 0.5; // px per ms

/** Downward drag offset for a sheet; upward drags clamp to 0. */
export function sheetDragOffset(startY: number, currentY: number): number {
  return Math.max(0, currentY - startY);
}

/** Whether a released drag should dismiss the sheet or spring it back open. */
export function shouldDismissSheet(dy: number, velocity: number, sheetHeight: number): boolean {
  return velocity > SHEET_DISMISS_VELOCITY || dy > sheetHeight * SHEET_DISMISS_DISTANCE_RATIO;
}

// A finger held still this long before release counts as stopped, not flicking.
export const SHEET_VELOCITY_STALE_MS = 100;

/** Release velocity, zeroed when the pointer paused before lifting. */
export function releaseVelocity(lastVelocity: number, msSinceLastMove: number): number {
  return msSinceLastMove > SHEET_VELOCITY_STALE_MS ? 0 : lastVelocity;
}
